export default function Footer() {
  return (
    <footer className="border-t border-sunset-amber/15 bg-plum-800/60" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="Southside Roleplay" className="h-10 w-10 rounded-lg border border-sunset-amber/40" />
          <div>
            <p className="font-display font-bold text-cream tracking-wide">SOUTHSIDE ROLEPLAY</p>
            <p className="text-xs text-muted-foreground">Where every story hits different.</p>
          </div>
        </div>
        <p className="text-xs text-muted-foreground text-center">
          Not affiliated with Rockstar Games or Take-Two Interactive. FiveM is a modification for Grand Theft Auto V.
        </p>
      </div>
    </footer>
  );
}
